<template>
    <div class="cmp-note td-card shadow fluid">
        <div v-if="isAdmin" class="note-admin-actions">
            <button class="td-btn secondary-outlined mr-1" title="Create Task" @click="createTask"><icon name="faPlus" type="solid"></icon></button>
            <button v-if="canProcess" class="td-btn primary-outlined" @click="process">Process</button>
            <button v-if="canUnprocess" class="td-btn primary-outlined" @click="unprocess">Undo Process</button>
        </div>
        <h5>
            {{ note.location }}
            <a class="icon-link" :href="locationUrl" title="View Location"><icon name="faEye" type="solid"></icon></a>
        </h5>
        <p class="cmp-note-detail td-text-subdued td-text-mice">{{ note.user}} - {{ formatDate(note.modified) }}<a class="icon-link" :href="userUrl" title="View User"><icon name="faEye" type="solid"></icon></a></p>
        <p class="cmp-note-comment">{{ note.comment }}</p>
        <div class="note-actions">
            <button v-if="canEdit" class="td-btn secondary-outlined" @click="openEdit">
                <icon name="faPencil" type="solid"></icon>
            </button>
            <button v-if="canEdit" class="td-btn danger" @click="openDelete">
                <icon name="faTrash" type="solid"></icon>
            </button>
        </div>
    </div>
    <transition name="modal">
        <modal @close="closeCreateTask" v-if="showCreateTask" class="edit-modal" hide-footer>
            <div class="td-edit-container one-step">
                <div class="pagination">
                    <div class="form-name">
                        <h3>Create Task</h3>
                    </div>
                    <div class="step-description">
                        <div class="step active">
                            <p>Create a task for the location.</p>
                        </div>
                    </div>
                </div>
                <div class="edit-pages">
                    <create-task :accountId="note.vendorId" :locationId="note.locationId" @complete="closeCreateTask" @cancel="closeCreateTask"></create-task>
                </div>
            </div>
        </modal>
    </transition>
    <transition name="modal">
        <modal @close="closeDelete" v-if="showDelete" hide-footer>
            <h4 class="td-h4">Are you sure you want to delete the note?</h4>
            <div class="actions">
                <button class="td-btn danger" title="Yes" @click="deleteNote">Yes</button>
            </div>
        </modal>
    </transition>
    <transition name="modal">
        <modal @close="closeEdit" v-if="showEdit" class="edit-modal" hide-footer>
            <div class="td-edit-container one-step">
                <div class="pagination">
                    <div class="form-name">
                        <h3>Edit Note</h3>
                    </div>
                    <div class="step-description">
                        <div class="step active">
                            <p>Enter your comment for the note.</p>
                        </div>
                    </div>
                </div>
                <div class="edit-pages">
                    <div class="form-page active td-form wide-form">
                        <label class="mt-0">Comment</label>
                        <textarea v-model="comment"></textarea>
                    </div>
                    <div class="actions">
                        <div class="pagination-btns"></div>
                        <div class="save-btn">
                            <button class="primary td-btn" title="Save Note" @click="editNote">Save Note</button>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </transition>
</template>


<script>
import script from './Note';
    export default script;</script>

<style lang="less">
    @import "./Note.less";
</style>